import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { BankAccountModel } from "./bankaccount.model";
import { BankAccountService } from "./bankaccount.service";
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { UserBankAccountsConst } from "../../user/const";
import { DummyComponent } from "../../../shared/dummy.component";
import { BankAccountComponent } from "./bankaccount.component";
import { ReconciliationConnectComponent } from "../../conciliation/connect/reconciliation-connect.component";
import { ReconciliationService } from "../../conciliation/reconciliation.service";
import { BankAccountsDialogMovimientoBancoComponent } from "./bankaccount-dialog-movimiento-banco.component";
import { BankAccountsDialogMovimientoEfectivoComponent } from "./bankaccount-dialog-movimiento-efectivo.component";
import { TableService } from "../../../shared/components/table/table.service";
import { AccountingAccountsModel } from "../../accounting/accounting-accounts/accounting-accounts.model";
import { AccountingAccountsService } from "../../accounting/accounting-accounts/accounting-accounts.service";
import { AccountingAccountsDialogLedgerComponent } from "../../accounting/accounting-accounts/accounting-accounts-dialog-ledger.component";
import { BankTypeEnum } from "../../../shared/data-types";
import { SubscriptionService } from "../../subscription/subscription.service";
import { consts } from "../../../consts";
import { Utils } from "../../../shared/utils";
import { BankTransactionImportImportComponent } from "../../conciliation/import/bank-transaction-import.component";

@Component({
    selector: "convfact-bankaccount-list",
    templateUrl: "./bankaccount-list.component.html",
    styleUrls: ["./bankaccount.component.css"],
    standalone: false
})
export class BankAccountListComponent implements OnInit {
  currentPage = 1;
  itemsPerPage = 10;
  totalItems = 0;

  constructor(
    private router: Router,
    private bankAccountService: BankAccountService,
    public dialog: MatDialog,
    public dummy: DummyComponent,
    private reconciliationService: ReconciliationService,
    public snackBar: MatSnackBar,
    private tableService: TableService,
    private accountingAccountsService: AccountingAccountsService,
    private subscriptionService: SubscriptionService,
  ) { }

  dataSource: BankAccountModel[] = [];
  empty = false;
  ready = false;
  headerTable: any[] = UserBankAccountsConst.headerTable;

  conciliation_active: boolean = false;

  public create(uid: string = undefined): void {
    uid = null;
    this.dialog.open(BankAccountComponent, {
      data: { uid: uid },
    });
  }

  public edit(uid: string): void {
    this.dialog.open(BankAccountComponent, {
      data: { uid: uid },
    });
  }

  public fiscalUse(uid: string) {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    this.bankAccountService
      .fiscalUse(uid)
      .then((response) => {
        this.dummy.redirectTo(this.router.url);
      })
      .catch((err) => {
        this.displayInfo(
          "Ha ocurrido un error al marcar la cuenta bancaria para la presentacion de impuestos"
        );
      });
  }

  public defaultRemittanceAccount(uid: string) {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    this.bankAccountService.defaultRemittanceAccount(uid)
      .then((response: string) => {

        this.displayInfo(response);

        this.dummy.redirectTo(this.router.url);

      })
      .catch(err => {
        this.displayInfo("Ha ocurrido un error al marcar la cuenta bancaria para las remesas");
      });
  }

  ngOnInit() {
    this.getList();
    this.getSubscriptionActives();
  }

  public getSubscriptionActives() {
    this.subscriptionService.getActive().then(response => {
      if (response && response.length > 0) {
        this.conciliation_active = response.filter(c => c.alias === 'SUBSCRIPTION_RECONCILIATION').length > 0;
      }
    });
  }

  public getList() {
    this.bankAccountService
      .getList(this.currentPage, this.itemsPerPage)
      .then((data) => {
        this.tableService.set(data.list);
        this.dataSource = data.list;
        this.totalItems = data.totalItems;
        if (this.dataSource.length == 0) {
          this.empty = true;
        } else {
          this.empty = false;
          this.getStatusConectionList();
        }
        this.ready = true;
      });
  }

  public pageChanged(event: any) {
    this.currentPage = event.page;
    this.getList();
  }

  private getStatusConectionList(): void {
    this.reconciliationService
      .getAllBankStatusRequisition()
      .then((response) => {
        if (response == null) {
          this.dataSource = this.dataSource.map((element) => {
            const value = element;
            value.connected = false;
            return value;
          });
        }

        if (response != undefined) {
          const resultUids = response.map((x) => x.bankId);

          this.dataSource = this.dataSource.map((element) => {
            const value = element;
            if (resultUids.includes(value.id)) {
              value.connected = true;
            } else {
              value.connected = false;
            }
            return value;
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  public connectBank(uid: string): void {
    if (!Utils.IsTierFive()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    const nameBank =
      this.dataSource.length > 0
        ? this.dataSource.find((x) => x.uid === uid).bank
        : "No definido";

    const bankSelected = this.dataSource.find(x => x.uid === uid);

    this.dialog.open(ReconciliationConnectComponent, {
      data: {
        bankId: bankSelected.id,
        bankTypeId: BankTypeEnum.Banco,
        bankName: nameBank,
      },
    })
      .afterClosed()
      .subscribe((bankId: string) => {

        if (bankId != null) {

          const bankIndex = this.dataSource.findIndex(x => x.id == bankSelected.id);

          if (bankIndex != -1) {
            this.dataSource[bankIndex].connected = false;
          }

        }

      });
  }

  public reconcile(uid: string): void {

    if (!this.conciliation_active) {
      if (!Utils.IsTierFour()) {
        this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
        return;
      }
    }

    const bankSelected = this.dataSource.find(x => x.uid === uid);

    this.router.navigate(["/finance/bankaccounts/", uid, "conciliation"], { queryParams: { bankId: bankSelected.id, bankTypeId: BankTypeEnum.Banco } });
  }

  public movimientobanco(uid: string, tipoMovimientoBancoId: number): void {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    const bankAccountSelected = this.dataSource.find((x) => x.uid === uid);

    this.dialog
      .open(BankAccountsDialogMovimientoBancoComponent, {
        // height: "50%",
        // width: "60%",
        data: {
          bankAccount: bankAccountSelected,
          tipoMovimientoBancoId: tipoMovimientoBancoId,
        },
      })
      .afterClosed()
      .subscribe((changes: boolean) => {
        if (changes) {
          this.dummy.redirectTo(this.router.url);
        }
      });
  }

  public movimientoefectivo(
    uid: string,
    tipoMovimientoEfectivoId: number
  ): void {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    const bankAccountSelected = this.dataSource.find((x) => x.uid === uid);

    this.dialog
      .open(BankAccountsDialogMovimientoEfectivoComponent, {
        // height: "50%",
        // width: "60%",
        data: {
          bankAccount: bankAccountSelected,
          tipoMovimientoEfectivoId: tipoMovimientoEfectivoId,
        },
      })
      .afterClosed()
      .subscribe((changes: boolean) => {
        if (changes) {
          this.dummy.redirectTo(this.router.url);
        }
      });
  }

  public displayInfo(message: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10000;
    this.snackBar.open(message, "", options);
  }

  public mayor(uid: string): void {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    const searchedElement = this.dataSource.find(x => x.uid == uid);

    let accountingModelsResponse: AccountingAccountsModel[] = [];
    let accountingModels: AccountingAccountsModel =
      new AccountingAccountsModel();

    this.accountingAccountsService
      .list(0, 1, searchedElement.accountNumber)
      .subscribe((x: any) => {
        accountingModelsResponse = x.data;

        if (accountingModelsResponse && accountingModelsResponse.length === 1) {
          accountingModels = accountingModelsResponse[0];
          accountingModels = accountingModelsResponse[0];
        }


        this.dialog.open(AccountingAccountsDialogLedgerComponent, {
          width: '700px',
          maxWidth: '96vw',
          
          maxHeight: '90vh',
          autoFocus: false,
          data: {
            id: accountingModels.id,
            name: accountingModels.name,
            number: accountingModels.number,
          },
        });
      });
  }

  public importTransactions(uid: string) {
    if (!this.conciliation_active) {
      if (!Utils.IsTierFour()) {
        this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
        return;
      }
    }

    const bankSelected = this.dataSource.find(x => x.uid === uid);

    this.dialog.open(BankTransactionImportImportComponent, {
      data: {
        bankId: bankSelected.id,
        bankTypeId: BankTypeEnum.Banco,
      }
    });
  }

}
